!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.featuredMediaSlider = {
    attach: function (context) {
      $('.featured-media-slider', context).each(function () {
        var $slider = $(this).find('.featured-media-slider__items.is-slider');
        var $controls = $(this).find('.featured-media-slider__controls');
        $slider.slick({
          appendDots: $controls,
          adaptiveHeight: true,
          cssEase: 'linear',
          dots: false,
          fade: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 1,
          speed: 200,
          prevArrow: $controls.find('.prev-slide'),
          nextArrow: $controls.find('.next-slide')
        });
      });
    }
  };
})(document, Drupal, jQuery);
